import { RootState } from 'src/store';
import { organizationInvitationSelector } from 'src/store/selectors';
import { OrganizationInvitation } from 'src/types/organizationInvitation.type';
import { useAppSelector } from '../store';

export const useInvitationsToOrganization = (): OrganizationInvitation[] => {
  const invitations = useAppSelector(
    (state: RootState) => state.organizationInvitation.organizationInvitations,
  );
  return invitations;
};

export const useInvitationsByReceiver = (): OrganizationInvitation[] => {
  const invitations = useAppSelector(organizationInvitationSelector.selectAll);
  return invitations;
};
